export const generateID = () =>  { return Array.from(Array(10), () => Math.floor(Math.random() * 36).toString(36)).join(''); }

export async function getUserLocationFromIP2(){
      const requestOptions = { method: 'GET',};
      if (AbortSignal?.timeout) {  requestOptions['signal'] =  AbortSignal.timeout(500)}
      const response = await fetch("http://www.geoplugin.net/json.gp", requestOptions)
      const result = await response.json()
      return result?.geoplugin_countryName
}

export async function getUserLocationFromIP(timeout=500){
    return new Promise((resolve, reject) => {
        const requestOptions = {
            method: 'GET',
        };
        if (AbortSignal?.timeout) {  requestOptions['signal'] =  AbortSignal.timeout(timeout)}
        let country = null;
        fetch("https://api.geoapify.com/v1/ipinfo?&apiKey=94fc430c15c343cc93b732537277a0cc", requestOptions)
            .then(response => response.json())
            .then(result => {  
              if (window.sessionStorage && result?.country?.currency) {
                window.sessionStorage.setItem('currency', result?.country?.currency)
              }
              country = result?.country?.names?.en; resolve(country)
            
            })
            .catch(error =>  { console.log('error', error); reject(error);   }  );
    })
}

export async function getUserLocationFromIPdata(timeout=500) {
  return new Promise((resolve, reject) => {
    const requestOptions = { method: 'GET',};
    if (AbortSignal?.timeout) { requestOptions['signal'] = AbortSignal.timeout(timeout) }
    fetch('https://api.ipdata.co?api-key=d5a756a764e248854368e06ff31e506948471e7c40bffa73c0dde8c8', requestOptions)
      .then(response => response.json())
      .then(result => {
        if (window.sessionStorage && result?.currency?.code) {
          window.sessionStorage.setItem('currency', result?.currency?.code)
        }
        resolve(result)
      })
      .catch(error => { console.log('user location err', error); reject(error); });
  })
}

export const getErrorMessage = (message) => {
  let errMessage = message;
  if (message.includes("auth/invalid-email"))
    errMessage = "Error: Enter a valid email address";
  if(message.includes('popup-closed-by-user'))
    errMessage = 'Authentication popup closed too early';
  else if(message.includes('email-already-in-use')) 
    errMessage = 'Email address is already registered with us. Please Sign in to continue.';
  // This is a different case that we will run into when user chooses a different sign in method from what they signed up with.
  //   ie  a user that has signed up with email and password, and then they will sign in with SSO
  else if(message.includes('account-exists-with-different-credential'))
    errMessage = 'Email address is already registered with us. Please use your original sign in method.';
  else if(message.includes('Error getting verification code from microsoft.com'))
    errMessage = 'Error getting verification code from microsoft.com';
  else if(message.includes('auth/missing-email'))
    errMessage = 'Please enter email address';
  else if (message.includes("user-not-found"))
    errMessage = "Email address is not in our records";
  else if (message.includes("wrong-password"))
    errMessage = "Entered password does not match";
  else if (message.includes("weak-password"))
    errMessage = "Password should be at least 6 characters";
  else if (message.includes("network-request-failed"))
    errMessage = "Network error. Check your connection and try again.";
  return errMessage;
}
